import { IContent } from '@_entities/content';
import { useUILayerStore } from '@_shared/stores/useUILayerStore';

import { ContentTitleEditPopup } from '../../ui';

export function useContentTitleEditPopup(content: IContent, contentTitle: string) {
	const { pushLayer } = useUILayerStore();

	function openContentTitleEditPopup() {
		pushLayer('popup', <ContentTitleEditPopup content={content} contentTitle={contentTitle} />);
	}

	return {
		openContentTitleEditPopup,
	};
}
